<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{ label?: string; isRequired?: boolean; isDisabled: boolean }>();
</script>

<template>
  <MMText
    font="Body M/Regular"
    :color="isDisabled ? 'disabled' : 'secondary'"
    v-if="label"
    :class="{ label_required: isRequired }"
  >
    {{ label }}
  </MMText>
</template>

<style lang="stylus" scoped>
.label
  &_required::after
    content '*'
    color var(--text-accented)
    margin-left 2px
</style>
